import { formatMakeModelYear } from '@edge/spark/utils'
import type { SearchVehicle } from '../types'

const MAX_LENGTH = 25

// TODO: rewrite logic for formating
export const makeModelYearIsNew = ({ make, model, year, isNew, stockNumber }: SearchVehicle): string => {
    const newTag = isNew === '1' ? 'NEW - ' : ''
    const mmy = formatMakeModelYear({ year, make, model }).toUpperCase()
    const mmyTooLong = mmy.length > MAX_LENGTH
    const mmyShort = `${mmy.substring(0, MAX_LENGTH)}…`
    const displayStockNumber = stockNumber && Number(stockNumber) !== 0 ? `(${stockNumber})` : ''
    return `${newTag} ${mmyTooLong ? mmyShort : mmy} ${displayStockNumber}`
}

/** @deprecated use makeModelYearIsNew */
export const newMakeModelYear = makeModelYearIsNew
